import React, { useEffect, useState } from "react";
import Navbar from "../../component/Navbar/Navbar";
import Sidebar from "../../component/sidebar/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteCash,
  getCashIn,
  selectCashes,
} from "../../redux/features/cashInOut/CashInOutSlice";
import {
  filterCashes,
  selectFilteredCashes,
} from "../../redux/features/filter/FilterSlice";
import ReactPaginate from "react-paginate";
import { sidebarSections } from "../Expenses/Expenses";
import cashInlogo from "../../Asset/cashIn logo.png";
import CashIn from "./CashIn";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";

const Cashes = () => {
  const [search, setSearch] = useState("");

  let cashes = useSelector(selectCashes);
  const filteredCashes = useSelector(selectFilteredCashes);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCashIn());
  }, [dispatch]);

  const confirmDelete = (id, note) => {
    if (!id || !note) {
      toast.error("ID or note is undefined");
      return;
    }
    confirmAlert({
      title: "Delete this cash entry",
      message: `Are you sure you want to delete this cash entry: "${note}"?`,
      buttons: [
        {
          label: "Delete",
          onClick: () => removeItem(id),
        },
        {
          label: "Cancel",
        },
      ],
    });
  };

  const removeItem = async (id) => {
    await dispatch(deleteCash(id));
    dispatch(getCashIn());
  };

  const priceSymbol = process.env.REACT_APP_PRICE_SYMBOL;

  const itemsPerPage = 10;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  const currentExpenses = filteredCashes?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filteredCashes?.length / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % filteredCashes?.length;

    setItemOffset(newOffset);
  };

  useEffect(() => {
    dispatch(filterCashes({ search, cashes }));
  }, [dispatch, search, cashes]);

  return (
    <div className="flex flex-col h-screen bg-[#F1F1F1]">
      {/* Navbar */}
      <Navbar page="Cash In" />

      <div className="flex flex-1 overflow-hidden ">
        {/* Sidebar */}
        <div className="md:w-[30%] w-[35%] bg-white shadow-md">
          <Sidebar sidebarSections={sidebarSections} />
        </div>

        {/* Main Content */}
        <div className="flex-1 p-8 relative overflow-y-auto  scrollbar-hide ">
          {/* Product List */}
          {cashes?.length > 0 ? (
            <>
              <div className="w-full  mx-auto mb-10 ">
                <div className="flex lg:justify-end justify-start my-4 items-center ">
                  <input
                    type="search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="bg-transparent py-2 px-4 border-2 border-[#A9A9A9]  rounded-full outline-none"
                    placeholder="Search by note..."
                  />
                </div>
                <div className="lg:space-y-4 space-y-2">
                  <div
                    className={`flex items-center justify-between lg:text-[1rem] text-[.8rem]  pb-0 w-full font-bold capitalize`}
                  >
                    <div className="flex items-center  w-[60%]">
                      <span className="w-[20%]">Sr #</span>

                      <span className=" w-[80%]  ">note</span>
                    </div>

                    <div className="flex items-center w-[40%]">
                      <div className=" w-[50%]">Price</div>

                      <div className="w-[50%]">Action</div>
                    </div>
                  </div>
                  {currentExpenses?.map((cash, index) => {
                    return (
                      <div
                        key={cash?._id}
                        className={`flex items-center justify-between lg:pt-4 pt-2 pb-0 border-t-2 border-[#DEDEDE]`}
                      >
                        <div className="flex items-center lg:text-[1rem] text-[.8rem]  w-[60%]">
                          <span className="w-[20%]">{index + 1}</span>

                          <span className="font-inter-600 text-wrap capitalize w-[80%] text-[#0D868C]">
                            {cash?.description}
                          </span>
                        </div>

                        <div className="flex items-center w-[40%] lg:text-[1rem] text-[.8rem]">
                          {cash?.balance > 0 && (
                            <div className="flex gap-2 items-center w-[50%]">
                              <span
                                className={`text-[#1E1E1E]  font-inter-400 `}
                              >
                                {priceSymbol} {cash?.balance}
                              </span>
                            </div>
                          )}

                          <div className="flex items-center md:gap-3 gap-1.5 w-[50%]">
                            <CashIn cash={cash} />
                            <span
                              onClick={() =>
                                confirmDelete(cash._id, cash?.description)
                              }
                              className="bg-[#f1524d] text-center text-white p-1 rounded-lg cursor-pointer"
                            >
                              <MdDelete className="lg:size-6 size-5" />
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {filteredCashes?.length > itemsPerPage && (
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel="Next"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={2}
                    pageCount={pageCount}
                    previousLabel="Prev"
                    renderOnZeroPageCount={null}
                    containerClassName="pagination"
                    pageLinkClassName="page-num"
                    previousLinkClassName="page-num"
                    nextLinkClassName="page-num"
                    activeLinkClassName="activePage"
                  />
                )}
              </div>

              <CashIn />
            </>
          ) : (
            <div className="flex items-center justify-center md:w-full w-[27rem]">
              <div className="md:w-[30rem] w-[25rem] lg:w-[38rem]  relative  lg:h-[30rem] h-[23rem] bg-[#A9A9A9] rounded-[2.4rem] text-white flex flex-col justify-center items-center ">
                <img
                  src={cashInlogo}
                  className="mb-2 size-16 md:size-32"
                  alt="Logo"
                />

                <p className="text-[1rem] md:text-[1.5rem] font-inter-700 text-center">
                  You have no Cash In yet
                </p>
                <p className="text-[.8rem] md:text-[1rem] font-inter-400 text-center">
                  To add a cash, press the (+) button
                </p>
                <CashIn />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Cashes;
